import {REHYDRATE} from 'redux-persist';

const initialState = {
  fetchingEmbedToken: false,
  embedToken: null,
  embedTokenFailed: false,
};

export default function reducer(state = initialState, action = {}) {

  switch (action.type) {

    case REHYDRATE:
      if (action.payload) {
        return {
          ...state,
          ...action.payload.marketingPlan,
          fetchingEmbedToken: false,
          embedToken: null,
          embedTokenFailed: false,
        };
      }
      return state;

    case 'MARKETING_PLAN_EMBED_TOKEN_FETCH_STARTED':
      return {
        ...state,
        fetchingEmbedToken: true,
        embedToken: null,
        embedTokenFailed: false,
      };

    case 'MARKETING_PLAN_EMBED_TOKEN_FETCH_SUCCEEDED':
      return {
        ...state,
        fetchingEmbedToken: false,
        embedToken: action.embedToken,
      };

    case 'MARKETING_PLAN_EMBED_TOKEN_FETCH_FAILED':
      return {
        ...state,
        fetchingEmbedToken: false,
        embedTokenFailed: true,
      };

    default:
      return state;
  }
}
